<template>
  <div>
    <b-button
      class="mb-2"
      variant="primary"
      @click="handleAddVersion"
    >
      <span
        class="text-nowrap"
      >Add Version</span>
    </b-button>
    <b-table
      :items="getVersionsList"
      responsive
      :fields="tableColumns"
      show-empty
      empty-text="No matching versions found"
      selectable
      :per-page="perPage"
      :current-page="currentPage"
      @row-selected="navigate"
    >
      <template #cell(createdAt)="data">
        {{ data.item.createdAt | formatDate }}
      </template>
      <template #cell(effectiveDateTime)="data">
        {{ data.item.effectiveDateTime | formatDate }}
      </template>
      <template #cell(published)="data">
        {{ data.item.published ? 'Yes': 'No' }}
      </template>
      <template #cell(actions)="data">
        <b-dropdown
          variant="link"
        >
          <template #button-content>
            <feather-icon
              icon="MoreVerticalIcon"
              size="16"
              class="align-middle text-body"
            />
          </template>
          <b-dropdown-item
            v-if="!data.item.published && $can('write', 'versions')"
            @click="deleteVersion(data.item.id)"
          >
            <feather-icon icon="TrashIcon" />
            <span class="align-middle ml-50">Delete</span>
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </b-table>
    <div class="mx-2 mb-2">
      <b-row>

        <!-- Pagination -->
        <b-col
          cols="12"
          sm="12"
          class="d-flex align-items-center justify-content-between"
        >
          <b-form-group
            class="mb-0"
          >
            <label class="d-inline-block text-sm-left mr-50">Per page</label>
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="perPageOptions"
              class="w-50"
            />
          </b-form-group>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalVersions"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>

        </b-col>

      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BTable, BDropdown, BDropdownItem, BButton, BPagination, BFormSelect, BFormGroup, BRow, BCol,
} from 'bootstrap-vue'
import { watch } from '@vue/composition-api'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import versionStore from '../store'
import useVersionsList from '../hooks/useVersionsList'
import { errorNotification } from '@/utils/toast-notifications'

export default {
  components: {
    BTable,
    BDropdown,
    BDropdownItem,
    BButton,
    BFormSelect,
    BPagination,
    BFormGroup,
    BRow,
    BCol,
  },
  props: {
    selectionInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, ctx) {
    const { businessId } = ctx.root.$route.query
    useRegisterStoreModule('versions', versionStore)
    const { versionsLoading, getVersionsList, ...rest } = useVersionsList(ctx, {
      selectedZone: props.selectionInfo.zone,
      selectedService: props.selectionInfo.service,
      businessId,
    })
    watch(versionsLoading, () => {
      ctx.emit('versions-loading-state', versionsLoading.value)
    }, { immediate: true })
    const handleAddVersion = () => {
      const query = {
        zone: props.selectionInfo.zone,
        service: props.selectionInfo.service,
        'service-class': props.selectionInfo.serviceClass,
      }

      if (businessId) {
        ctx.root.$router.push({
          path: '/businesses/versions/new',
          query: {
            ...query,
            businessId,
          },
        })
      } else {
        ctx.root.$router.push({
          path: '/versions/new',
          query,
        })
      }
    }
    const navigate = evt => {
      if (!evt[0].id) {
        errorNotification('No ID provided..')
        return
      }
      const query = {
        zone: props.selectionInfo.zone,
        service: props.selectionInfo.service,
        'service-class': props.selectionInfo.serviceClass,
      }
      if (businessId) {
        ctx.root.$router.push({
          path: `/businesses/versions/edit/${evt[0].id}`,
          query: {
            ...query,
            businessId,
          },
        })
      } else {
        ctx.root.$router.push({
          path: `/versions/edit/${evt[0].id}`,
          query,
        })
      }
    }
    return {
      navigate,
      ...rest,
      getVersionsList,
      handleAddVersion,
    }
  },
  methods: {
    async deleteVersion(id) {
      await this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
        showLoaderOnConfirm: true,
        preConfirm: res => {
          if (!res) return null
          return this.$store.dispatch('versions/deleteVersion', id).catch(err => {
            this.$swal.showValidationMessage(`Request failed:  ${err.response.data.error.detail.message}`)
          })
        },
      }).then(result => {
        if (result.value) {
          this.$swal({
            icon: 'success',
            title: 'Deleted!',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
  },
}
</script>

<style>

</style>
